<template>
  <div >
    <div class="t_out_box">
      <!-- <div class="t_search_box">
        <div class="t_con_w" style="padding-top: 30px; padding-bottom: 27px">
          <el-form
            class="t_search_form"
            label-position="left"
            label-width="90px"
          >
            <el-form-item label="操作人：" label-width="70px">
              <el-input placeholder="请输入操作人姓名"></el-input>
            </el-form-item>
            <el-form-item label="下发时间：">
              <el-date-picker type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-button class="t_search_btn" type="primary">搜索</el-button>
          </el-form>
        </div>
      </div> -->
      <div
        class="t_table_box"
        style="padding-top: 20px; padding-bottom: 74px; margin-top: 20px"
      >
        <div class="t_con_w" style="padding-top: 10px; padding-bottom: 30px">
          <div class="t_tips_box">
            <img src="@/assets/img/tips.png" alt="">
            提示：请先下载责任书打印盖章，确认无误后拍照上传并提交！
          </div>
          <el-button
            v-preventReClick
            size="mini"
            style="
              background-color: #ff8700;
              border: none;
              color: white;
              margin-bottom: 10px;
            "
            @click="downLoad"
          >下载模板</el-button>
          <el-button
            v-preventReClick
            size="mini"
            style="
              background-color: #ffb50d;
              border: none;
              color: white;
              margin-bottom: 10px;
            "
            @click="upinfo"
          >上传</el-button>
          <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
            style="
              width: 100%;
              border-left: 1px solid #f4f4f4;
              border-right: 1px solid #f4f4f4;
            "
          >
            <el-table-column
              align="center"
              prop="yxq"
              label="有效期"
              width="400"
            >
              <template slot-scope="scope">
                {{ scope.row.yzqKs + " 至 " + scope.row.yzqJs }}
              </template>
            </el-table-column>
            <el-table-column
              width="160"
              align="center"
              prop="tjsj"
              label="签订日期"
            />
            <el-table-column align="center" prop="ztLabel" label="签署状态">
              <template slot-scope="scope">
                <span
                  :style="
                    scope.row.zt == '13'
                      ? { color: 'blue' }
                      : { color: 'green' }
                  "
                >
                  {{ scope.row.ztLabel }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="tjrIdLabel" label="操作人" />
            <el-table-column
              align="center"
              prop="cz"
              width="250px"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  size="mini"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="lookItem(scope.row)"
                >查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            class="el-page"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="查看"
      :visible.sync="dialogVisible"
      width="500"
    >
      <div style="text-align: center">
        <el-image
          :preview-src-list="ImgList"
          :src="
            activeRow.wjdz
              ? this.returnShowPic + activeRow.wjdz
              : '@/assets/img/zrs.png'
          "
          draggable="false"
          style="width: 300px; height: 138px"
        />
      </div>
      <div>
        <div class="_title _title2" style="width: 100%">
          <p class="_title_info" style="font-weight: bold; text-align: center">
            公安审批结果
          </p>
        </div>
        <el-timeline>
          <el-timeline-item
            v-if="activeRow.sphjDtoList[0]"
            icon="el-icon-time"
            size="large"
          >
            <div style="margin-top: 2px">
              <span style="font-weight: bold"> 申请时间： </span>
              <span>{{ activeRow.sphjDtoList[0].clsj }}</span>
            </div>
          </el-timeline-item>
          <el-timeline-item
            v-for="(item, index) in activeRow.sphjDtoList"
            :key="index"
            :icon="
              index == activeRow.sphjDtoList.length - 1 ? 'el-icon-success' : ''
            "
            :type="item.type"
            :size="
              index == activeRow.sphjDtoList.length - 1 ? 'large' : item.size
            "
            :color="item.color"
          >
            <div style="display: flex">
              <div style="margin-right: 20px">
                <span style="font-weight: bold">审批单位：</span>{{ item.dqbmLabel }}
              </div>
              <div
                v-if="item.sftyLabel !== '待审批'"
                style="margin-right: 20px"
              >
                <span style="font-weight: bold">{{ item.jsLabel }}人：</span>{{ item.sjsprLabel }}
              </div>
              <div style="margin-right: 20px">
                <span style="font-weight: bold">审批结果：</span><span
                  :style="
                    item.sftyLabel == '同意'
                      ? 'color: #00ceb7'
                      : item.sftyLabel == '不同意'
                        ? 'color: red'
                        : 'color: Orange'
                  "
                >{{ item.sftyLabel }}</span>
              </div>
              <div
                v-if="item.sftyLabel !== '待审批'"
                style="margin-right: 20px"
              >
                <span style="font-weight: bold">审批时间：</span>{{ item.spsj }}
              </div>
            </div>
            <div v-if="item.sftyLabel !== '待审批'" style="margin-top: 2px">
              <span style="font-weight: bold">审批意见：</span><span>{{ item.spyj }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border-color: #4170ff"
          @click="dialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-loading = "loading"
      title="上传"
      :visible.sync="upwindow"
      width="30%"
      center
      @close="closeDialog"
    >
      <div class="myUpload" style="text-align: center">
        <el-upload
          :action="returnSaveFile"
          list-type="picture-card"
          :limit="1"
          :on-preview="handlePictureCardPreview"
          :before-upload="beforeUpload"
          :headers="token"
          :class="{ disabled: showUpload }"
          :on-success="handleSuccess"
          :file-list="fileList"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus" />
        </el-upload>
        <!-- <el-dialog
          :close-on-click-modal="false"
          :closeOnPressEscape="false"
          append-to-body
          :visible.sync="imgVisible"
        >
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="closeDialog">取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="upfile"
        >上传</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 获取接口地址
import { getDwzrs, saveDwzrs, getDetail } from '@/assets/js/zrsqd.js'
import { getToken, returnShowPic, returnSaveFile } from '@/assets/js/common.js'
export default {
  name: 'Zrsqd',
  components: {},
  data() {
    return {
      loading: false,
      returnShowPic: '', // 查看图片的URL前缀
      returnSaveFile: '',
      // 当前数据
      activeRow: {
        sphjDtoList: []
      },
      showUpload: false, // 控制上传按钮的样式
      // 分页
      total: 0,
      pagesize: 10,
      currentPage: 1,
      dialogImageUrl: '', // 弃置
      imgVisible: false, // 弃置
      dialogVisible: false, // 关闭详情弹窗
      upwindow: false, // 上传dialog开关
      tableData: [], // 表格数据
      ImgList: [], // 查看详情时的文件列表
      fileList: [], // 文件列表
      token: {
        Authorization: getToken()
      }
    }
  },
  created() {
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    this.loadData()
  },
  methods: {
    // 关闭dialog 并清空文件列表
    closeDialog() {
      this.showUpload = false
      this.upwindow = false
      this.wjdz = ''
      this.fileList = []
    },
    // 下载
    downLoad() {
      const link = document.createElement('a')
      link.href = './zrs.doc'
      link.download = '模板'
      link.click()
    },
    // 查看详情
    lookItem(row) {
      getDetail(row.id).then((e) => {
        this.activeRow = e.data.data
        this.ImgList = [this.returnShowPic + this.activeRow.wjdz]
        this.dialogVisible = true
      })
    },
    // 移除图片时将修改样式
    handleRemove(file, fileList) {
      if (fileList.length == 0) {
        this.showUpload = false
      }
    },
    // 获取文件地址 限制上传一张
    handleSuccess(response, file, fileList) {
      this.wjdz = response.data.url
      if (fileList.length == 1) {
        this.showUpload = true
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadData()
    },
    // 查询
    loadData() {
      getDwzrs({
        page: this.currentPage,
        size: this.pagesize,
        param: {}
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 上传时 打开dialog
    upinfo() {
      this.upwindow = true
    },
    // 确定上传
    upfile() {
      if (this.wjdz) {
        this.$confirm("上传成功后须<span style='color: red;font-size: 18px'>重新登录</span>启用该责任书，</br>是否确认提交?", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString:true,
          type: 'warning'
        })
          .then(() => {
            this.loading = true
            saveDwzrs({ wjdz: this.wjdz }).then((e) => {
              this.loading = false
              if (e.data.code == '000000') {
                this.upwindow = false
                this.loadData()
                this.$message({
                  type: 'success',
                  message: '提交成功，须重新登录启用该责任书!'
                })
              }
            }).catch((error) => {
              this.upwindow = false
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      } else {
        this.$message.error('请先上传文件')
      }
    },
    // 限制图片格式
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp']
      const isLt2M = file.size / 1024 < 500
      const typeTrue = fileType.includes(file.type)
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500k!')
      }
      if (!typeTrue) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      return typeTrue && isLt2M
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.imgVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.spResult {
  width: 90%;
  max-width: 950px;
  display: flex;
  margin: auto;
  flex-wrap: wrap;
  div {
    margin-right: 30px;
  }
  .spjg {
    display: flex;
    align-items: center;
  }
}
.t_out_box {
  width: 95%;
  max-width: 1518px;
  margin-left: auto;
  margin-right: auto;
}
.t_search_box {
  margin-top: 30px;
  margin-bottom: 10px;
  box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
}
.t_search_box,
.t_table_box {
  background-color: white;
}
.t_con_w {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.t_search_form {
  display: flex;
}
.t_search_form .el-form-item {
  margin-right: 55px;
  margin-bottom: 0;
}
.t_search_btn {
  width: 90px;
  height: 39px;
  background-color: #4170ff;
}
.t_tips_box {
  display: flex;
  align-items: center;
  color: #434343;
  font-size: 13px;
  margin-bottom: 20px;
}
.t_tips_box img {
  width: 15px;
  margin-right: 5px;
}
.el-pagination {
  padding: 10px 0;

  border: 1px solid #ebeef5;
  border-top: 0;
}
/deep/ .disabled .el-upload--picture-card {
  display: none;
}
/deep/ .el-table .has-gutter tr th {
  background: #eaeaea !important;
}
/deep/.el-timeline-item__icon {
  font-size: 16px !important;
  color: #fff;
  background-color: #ef9a12;
  border-radius: 50%;
}
/deep/.el-icon-success {
  color: #6acd18;
  background-color: #fff;
}
</style>
